import PropTypes from 'prop-types';
import React from 'react';
import SingleAemEspot from '../../SingleAemEspot';
import styles from './menu.module.scss';

const MenuGroup = ({
  children, heading, headingKey = '', label = '', topEspotIdentifier,
}) => (
  <div aria-label={label} className={styles.container}>
    {heading ? (
      <h2 className={styles.heading} data-property={headingKey}>{heading}</h2>
    ) : null}
    {topEspotIdentifier ? (
      <SingleAemEspot espotId={topEspotIdentifier} />
    ) : null}
    <div className={styles.group}>{children}</div>
  </div>
);

MenuGroup.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string,
  headingKey: PropTypes.string,
  label: PropTypes.string,
  topEspotIdentifier: PropTypes.string,
};

export default MenuGroup;
